<template>
  <ion-app>
    <ion-router-outlet />
  </ion-app>
</template>

<script setup lang="ts">
import pkg from '@root/package.json'
import { useStore } from 'vuex'
import getProfile from '@/assets/ts/getProfile'
import useFavourites from '@/assets/ts/useFavourites'
import useMacros from '@/assets/ts/useMacros'
import useNewGoal from '@/assets/ts/useNewGoal'
import useUserTimezone from '@/assets/ts/utilities/timezones/useUserTimezone'
import { configureSentryScope } from '@/plugins/sentry'
import router from '@/router'
import { useProfileStore } from '@/store/profile'
import useStoreFavourites from '@/store/useStoreFavourites'

const store = useStore()
const { macros } = useMacros()
const { checkUserTimezone } = useUserTimezone()
const { goalData, getGoalData } = useNewGoal()
const $store = useProfileStore()
const $favouritesStore = useStoreFavourites()
const programStore = useStoreProgramNew()
const workoutWeekStore = useStoreWorkoutWeek()
const profileStore = useStoreProfile()
const sessionStore = useStoreSession()
const { getFavourites } = useFavourites();

( async () => {

  store.state.loading = true

  if ( window.location.pathname === '/login' ) return false
  let profile = null

  try {
    const response = await getProfile()
    // Handle 403 error.
    if ( response.response && response.response.status !== 200 ) {
      router.push( '/login' )
      return false
    } else {
      profile = response
    }
  } catch ( error ) {
    router.push( '/login' )
    console.error( 'Error getting profile', error )
  }

  if ( profile && store ) {
    store.state.profile = profile
    profileStore.profile = profile
    configureSentryScope( store.state.profile.ID, store.state.profile.contactInfo.emailAddress, pkg.version )
    const [ favourites, goal ] = await Promise.all( [
      getFavourites( store.state.profile.ID ),
      getGoalData( store.state.profile.ID )
    ] )
    $favouritesStore.favourites = favourites
    $store.$patch( profile )
    macros.value = store.state.profile.macros
    goalData.value = goal
    if ( ! store.state.profile.currentProgram.id ) {
      store.state.loading = false
      return false
    }
    // const response = await getProgram( store.state.profile.currentProgram.id )
    await programStore.initializeProgram( store.state.profile.currentProgram.id )

    await checkUserTimezone()

    if ( programStore.program.program ) {
      // programStore.program.workoutWeekNumber = store.state.profile.currentProgram.workoutWeek
      /**
         * TODO: Replace lastSession with a check for a local session first.
         * If it exists, use that. If not, get the last session.
         */
      // lastSession.value = await getLastSession( store.state.profile.ID, store.state.profile.currentProgram.id )
      await workoutWeekStore.initializeWorkoutWeek( store.state.profile.ID )
      // sessionStore.previousSession = await sessionStore.getPreviousSession( store.state.profile.ID, programStore.program.program.ID )
    }
    store.state.loading = false
    store.state.profile.ready = true
    if ( ! profileStore.profile.totalSessionsCompleted ) {
      profileStore.profile.totalSessionsCompleted = await profileStore.getTotalSessions( store.state.profile.ID )
    }

    // Retry syncing any session that was saved locally while offline.
    if ( sessionStore.pendingSession ) {
      sessionStore.syncPendingSession()
    }

    return true
  }
  return true
} )()
</script>
